"use client";

import * as React from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

function MapboxMap({ className, center, zoom, markers }) {
  const map = React.useRef(null);
  const mapNode = React.useRef(null);

  React.useEffect(() => {
    const node = mapNode.current;

    if (typeof window === "undefined" || node === null) return;

    mapboxgl.accessToken = "pk.eyJ1IjoidGhpYm9kZWF1eGpsIiwiYSI6ImNrMDczcnJzcjM3YzIzZHFkbDJyeTJicmEifQ.4MiRLa2k9aNDNKoVvIduSQ";

    map.current = new mapboxgl.Map({
      container: node,
      style: "mapbox://styles/thibodeauxjl/cktaor1c3536417nkp6oav785",
      center: center,
      zoom: zoom,
      interactive: false,
      dragPan: false,
      scrollZoom: false,
      doubleClickZoom: false,
    });
    
    const marker = new mapboxgl.Marker({ color: "#ff2740" })
                  .setLngLat(markers)
                  .addTo(map.current);

    return () => {
      map.current.remove();
    };
  }, [center, zoom, markers]);

  return <div ref={mapNode} className={className} />;
}

export default MapboxMap;
